import { AxiosResponse } from "axios";
import httpClient from "../../api/httpClient";
import Utils from "../../helper/utils";
import ForecastDiarizado from "../classes/ForecastDiarizado";
import ForecastDiarizadoEstoqueConsumido from "../classes/ForecastDiarizadoEstoqueConsumido";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "Forecast/Diarizado/{int id}" },
  { method: "POST", rota: "Forecast/Diarizado/Adicionar" },
  { method: "PUT", rota: "Forecast/Diarizado/Atualiza" },
  { method: "DELETE", rota: "Forecast/Diarizado/Apagar" },
  { method: "GET", rota: "Forecast/Diarizado/" },
  { method: "POST", rota: "Forecast/Diarizado/Atualiza/Colecao" },
  { method: "GET", rota: "Forecast/Diarizado/ObterPercentualConsumido" },
  { method: "GET", rota: "Forecast/Diarizado/RecuperarPorFiltro/" },
  { method: "POST", rota: "Forecast/Diarizado/Estornar/Colecao" }
];

const cacheKey: string = "ForecastDiarizadoCache";
const cacheKeySelC: string = "ForecastDiarizadoCacheSelecionado";

const apiServico: String = "PLANEJAMENTO";

class ForecastDiarizadoDataset extends httpClient {
  constructor() {
    super(String(apiServico));
  }
  Adicionar(value: ForecastDiarizado) {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .post(calls[1].rota, value)
      .then((result) => {
        ok = JSON.parse(result);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
  }

  async RecuperarPorFiltros(filters: any, codigoFornecedorSap: number, passo: number): Promise<ForecastDiarizado[]> {
    const baseURL = calls[7].rota + passo;
    // key = exampleKey -> ExampleKey
    // queryFilters result -> ExampleKey=123&OtherKey=321
    const queryFilters = Object.entries(filters).filter(([, value]) => !!value).map(([key, value]) => `${Utils.firstLetterToUpperCase(key)}=${value}`).join('&');
    const query = `?CodigoFornecedorSap=${codigoFornecedorSap}&${queryFilters}`;

    try {
      return super.Get(`${baseURL}${query}`).then(response => response.data);
    } catch (erro) {
      console.log(erro);
      return [];
    }
  }

  async Atualizar(value: ForecastDiarizado) {
    return super
      .put(calls[2].rota, value)
      .then((result) => {
        return result;
      })
      .catch((erro) => {
        console.log(erro);
        return false;
      });
  }

  async AtualizarColecao(value: ForecastDiarizado[]): Promise<boolean> {
    try {
      const result = await super.post(calls[5].rota, value);
      return result;
    } catch (erro) {
      console.log(erro);
      return false;
    }
  }

  Apagar(value: ForecastDiarizado) {
    let ok: boolean = false;
    let error: any = undefined;
    super
      .delete(calls[3].rota, value)
      .then((result) => {
        ok = JSON.parse(result);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
  }

  async ListarAtivos(
    codigoFornecedorSap: number,
    numeroContrato: string
  ): Promise<ForecastDiarizado[]> {
    return await super
      .Get(calls[4].rota + codigoFornecedorSap + "/Contrato/" + numeroContrato)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro);
      });
  }

  async ListarAtivosPorPasso(
    codigoFornecedorSap: number,
    numeroContrato: string,
    passo: number
  ): Promise<ForecastDiarizado[]> {
    return await super
      .Get(
        calls[4].rota +
        codigoFornecedorSap +
        "/Contrato/" +
        numeroContrato +
        "/Passo/" +
        passo
      )
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro);
        return [];
      });
  }

  async obterPercentualConsumido(forecastDiarizadoEstoqueConsumido: ForecastDiarizadoEstoqueConsumido): Promise<number> {
    let percentual: number;
    let ok: boolean = false;
    let error: any = undefined;
    let url: string = `${calls[6].rota}?CodigoFornecedorSap=${forecastDiarizadoEstoqueConsumido.codigoFornecedorSap}&NumeroContrato=${forecastDiarizadoEstoqueConsumido.numeroContrato}&CodigoSku=${forecastDiarizadoEstoqueConsumido.codigoSku}&Centro=${forecastDiarizadoEstoqueConsumido.centro}&MesAnoReferencia=${forecastDiarizadoEstoqueConsumido.mesAnoReferencia}&Dia=${new Date(forecastDiarizadoEstoqueConsumido.dia).toISOString()}`
    await super
      .Get(url)
      .then((response: AxiosResponse) => {
        ok = response.status == 200;
        percentual = response.data;
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<number>((resolve) => {
      resolve(percentual);
    });
  }

  async Estornar(value: ForecastDiarizado[]) {
    try {
      const result = await super
        .post(calls[8].rota, value);
      return JSON.parse(result);
    } catch (erro) {
      console.log(erro);
      return false;
    }
  }

  getKeyCach(): string {
    return cacheKey;
  }

  getKeyCachClass(): string {
    return cacheKeySelC;
  }

  ListarFromCache(): ForecastDiarizado[] {
    let result: ForecastDiarizado[] = JSON.parse(cacheKey);
    return result;
  }

  AdicionarListaAoCache(value: ForecastDiarizado[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  LimparListaDoCache() {
    localStorage.removeItem(cacheKey);
  }

  LimparObjetoDoCache() {
    localStorage.removeItem(cacheKeySelC);
  }
}
export default ForecastDiarizadoDataset;
